export const BRIEF_SECTIONS = [
  {
    id: "company",
    num: "01",
    title: "Company",
    blurb: "Who is considering India.",
    fields: [
      { id: "company_name", label: "Company / organisation name", type: "text", required: true },
      { id: "hq", label: "Headquarters — country and city", type: "text", required: true },
      { id: "website", label: "Website", type: "text", required: false, placeholder: "https://" },
      { id: "industry", label: "Industry / sector", type: "text", required: true },
      {
        id: "company_size",
        label: "Company size (employees)",
        type: "select",
        required: false,
        options: ["Fewer than 50", "50 – 250", "250 – 1,000", "1,000 – 5,000", "More than 5,000"],
      },
      {
        id: "revenue_band",
        label: "Global revenue band",
        type: "select",
        required: false,
        options: ["Under US$10m", "US$10m – 50m", "US$50m – 250m", "US$250m – 1bn", "Over US$1bn", "Prefer not to say"],
      },
      { id: "contact_name", label: "Decision contact — name", type: "text", required: true },
      { id: "contact_role", label: "Decision contact — role", type: "text", required: true },
      { id: "contact_email", label: "Decision contact — email", type: "email", required: true },
      { id: "contact_phone", label: "Decision contact — phone", type: "tel", required: false },
      {
        id: "others_copy",
        label: "Others who should receive correspondence (names / emails)",
        type: "textarea",
        required: false,
        full: true,
      },
    ],
  },
  {
    id: "product",
    num: "02",
    title: "Product / Service",
    blurb: "What you would bring to India.",
    fields: [
      {
        id: "product_description",
        label: "Describe your product / service",
        type: "textarea",
        required: true,
        full: true,
        help: "What it does, who buys it, and why they buy it.",
      },
      { id: "product_categories", label: "Product families / categories", type: "text", required: false },
      {
        id: "differentiators",
        label: "Key differentiators / USP",
        type: "textarea",
        required: false,
        full: true,
      },
      { id: "certifications", label: "Certifications held (e.g. ISO, CE, FDA, BIS)", type: "text", required: false },
      { id: "home_price_range", label: "Typical price range in your home market", type: "text", required: false },
      { id: "manufacturing_origin", label: "Where the product is manufactured / sourced", type: "text", required: false },
    ],
  },
  {
    id: "objective",
    num: "03",
    title: "Your India Objective",
    blurb: "What the decision is for.",
    fields: [
      {
        id: "primary_objective",
        label: "Primary objective in India",
        type: "select",
        required: true,
        options: [
          "Assess the market opportunity",
          "Enter the market for the first time",
          "Scale existing sales",
          "Find partners, distributors or agents",
          "Set up a local presence or operations",
          "Other (describe below)",
        ],
      },
      {
        id: "objective_detail",
        label: "Describe your objective in your own words",
        type: "textarea",
        required: false,
        full: true,
      },
      { id: "target_segments", label: "Target customer segments", type: "text", required: false },
      { id: "target_geographies", label: "Target regions / cities in India (if known)", type: "text", required: false },
      {
        id: "investment_appetite",
        label: "Investment appetite for India entry",
        type: "select",
        required: false,
        options: ["Not yet defined", "Under US$100k", "US$100k – 500k", "US$500k – 1m", "Above US$1m"],
      },
      {
        id: "timeline",
        label: "Timeline for the decision",
        type: "select",
        required: true,
        options: ["Immediate", "Within 3 – 6 months", "Within 6 – 12 months", "12 months or more", "Exploratory only"],
      },
    ],
  },
  {
    id: "position",
    num: "04",
    title: "Current India Position",
    blurb: "Where you already stand.",
    fields: [
      {
        id: "sold_to_india",
        label: "Have you sold into India before?",
        type: "radio",
        required: true,
        options: ["Yes", "No"],
      },
      {
        id: "india_revenue_band",
        label: "Current India revenue band",
        type: "select",
        required: false,
        visibleWhen: { field: "sold_to_india", equals: "Yes" },
        options: ["Under US$100k", "US$100k – 500k", "US$500k – 1m", "Above US$1m", "Prefer not to say"],
      },
      {
        id: "india_channels",
        label: "Current routes to India",
        type: "checkbox-group",
        required: false,
        visibleWhen: { field: "sold_to_india", equals: "Yes" },
        options: ["Direct exports", "Distributor / importer", "Sales agent / representative", "E-commerce / marketplaces", "Local office or subsidiary", "Other"],
      },
      {
        id: "india_presence_detail",
        label: "Describe your current India activity",
        type: "textarea",
        required: false,
        visibleWhen: { field: "sold_to_india", equals: "Yes" },
        full: true,
      },
      {
        id: "india_contacts",
        label: "Existing India contacts, partners or enquiries",
        type: "textarea",
        required: false,
        full: true,
      },
      {
        id: "india_entity",
        label: "Do you have a registered entity or registrations in India?",
        type: "radio",
        required: false,
        options: ["Yes", "No"],
      },
      {
        id: "india_entity_detail",
        label: "Entity / registration details",
        type: "text",
        required: false,
        visibleWhen: { field: "india_entity", equals: "Yes" },
        full: true,
      },
      {
        id: "india_visits",
        label: "Visits to India for this opportunity",
        type: "select",
        required: false,
        options: ["None", "1 – 2 visits", "3 or more visits"],
      },
    ],
  },
  {
    id: "competitive",
    num: "05",
    title: "Competitive Intelligence",
    blurb: "Who else is in the field.",
    fields: [
      {
        id: "competitors",
        label: "Competitors known to you (up to three)",
        type: "competitors",
        required: false,
        rows: 3,
        full: true,
      },
      {
        id: "competitor_positioning",
        label: "How do you believe competitors are positioned in India?",
        type: "textarea",
        required: false,
        full: true,
      },
      { id: "competitor_sources", label: "Sources of your competitive information", type: "text", required: false },
    ],
  },
  {
    id: "commercial",
    num: "06",
    title: "Commercial & Entry Parameters",
    blurb: "The economics of entry.",
    fields: [
      {
        id: "price_positioning",
        label: "Expected price positioning in India",
        type: "select",
        required: false,
        options: ["Premium", "At parity with local market", "Value / competitive"],
      },
      {
        id: "unit_economics",
        label: "Unit economics / margin sensitivities",
        type: "textarea",
        required: false,
        full: true,
      },
      {
        id: "entry_routes",
        label: "Entry routes you would consider",
        type: "checkbox-group",
        required: false,
        options: ["Direct exports", "Distributor / importer", "Sales agent / representative", "Strategic partner", "Joint venture", "Own subsidiary", "Undecided — recommend"],
      },
      {
        id: "regulatory_gates",
        label: "Regulatory gates you are aware of (e.g. BIS, CDSCO, DGFT, FSSAI, customs)",
        type: "textarea",
        required: false,
        full: true,
      },
      {
        id: "localisation",
        label: "Willingness to localise (product / operations)",
        type: "select",
        required: false,
        options: ["None", "Some", "Full localisation"],
      },
    ],
  },
  {
    id: "management",
    num: "07",
    title: "Management Questions & Materials",
    blurb: "Anything this brief should answer.",
    fields: [
      {
        id: "questions_for_enexur",
        label: "Questions you want this engagement to answer",
        type: "textarea",
        required: false,
        full: true,
      },
      {
        id: "success_definition",
        label: "What would make this engagement a success?",
        type: "textarea",
        required: false,
        full: true,
      },
      {
        id: "files_catalogue",
        label: "Product catalogue / technical specifications",
        type: "file",
        required: false,
        multiple: true,
        help: "PDF, image or document files.",
        full: true,
      },
      {
        id: "files_research",
        label: "Existing market research or India-related materials",
        type: "file",
        required: false,
        multiple: true,
        full: true,
      },
      {
        id: "files_profile",
        label: "Company profile / investor deck",
        type: "file",
        required: false,
        multiple: true,
        full: true,
      },
      {
        id: "privacy_consent",
        label: "I confirm that I am authorised to share this information on behalf of the company named above, and I consent to ENEXUR processing it to prepare a response to this brief.",
        type: "consent",
        required: true,
        full: true,
      },
    ],
  },
];

export const PRIVACY_NOTE =
  "Your responses are treated as confidential and are used solely to prepare ENEXUR's response to this brief. Materials are shared only with the ENEXUR team working on your engagement.";
